import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import api from './../../api';
import { useSelector } from 'react-redux';
import Alert from '@material-ui/lab/Alert';
import Snackbar from "@material-ui/core/Snackbar";
import Paper from '@material-ui/core/Paper';
import { Grid, Typography, Card, ButtonBase, Divider } from '@material-ui/core';
import { Box } from '@material-ui/core';
import FormControl from "@material-ui/core/FormControl";
import { Map, ImageOverlay, Marker, Tooltip, ZoomControl } from 'react-leaflet';
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import Select from "@material-ui/core/Select";
import SemiCircleProgressBar from "react-progressbar-semicircle";
// import image from './../../assets/img/CT.png'
import image from './../../assets/img/Chiller_plant-5.png'
import Success from 'components/Typography/Success';
import Warning from "components/Typography/Warning";
import Danger from "components/Typography/Danger";
import TimeS from "./../TimeS";
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import SwitchSelector from "react-switch-selector";
import ChillerReports from "./glChillerReports";
import PumpPage from "./GlPrimaryPump";
import CreateIcon from '@material-ui/icons/Create';
import LandingPage from './../../views/Heatmap/upsEmsLanding';
import Tooltip1 from '@material-ui/core/Tooltip';
import { element } from 'prop-types';
import { redColor, yellowColor, greenColor, whiteColor, grayColor, blackColor, blueColor, hexToRgb } from "assets/jss/material-dashboard-react.js";

const Leaflet = require('leaflet');

const StyledTooltip = withStyles({
  tooltip: {
    color: "black",
    backgroundColor: "#FEE8DA",
    // backgroundColor: "red",
    fontSize:"12px"
  }
})(Tooltip1);

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  faults_paper: {
    // padding: theme.spacing(1),
    // borderRadius:"37px",
    color:"white",
    display:'flex',
    textAlign:"center",
    alignItems: 'center',
     justify: 'center',
    //  height:'3.5vh',
     backgroundColor: 'blue',
    // [theme.breakpoints.down('sm')]: {
    //   width:"7.5vh"
    // },
    // [theme.breakpoints.up('md')]: {
    //   width:"6vh"
    // },
    // [theme.breakpoints.up('lg')]: {
    //   width:"7.5vh"
    // },
    // [theme.breakpoints.up('xl')]: {
    //   width:"7.5vh"
    // },
  },
});

const processDataFromJson = false;

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const useStyles = makeStyles((theme) => ({
  customDialogPump: {
    cursor:"pointer",
    // Set the desired width for the dialog
    height: window.innerHeight=='1080'?'496px':'330px', // Adjust this value as needed
    "max-width": window.innerHeight=='1080'?'1700px':'700px', // Adjust this value as needed
    // width: '700px', // Adjust this value as needed
  },
  customDialog: {
    cursor:"pointer",
    // Set the desired width for the dialog
    height: '480px', // Adjust this value as needed
    width:window.innerHeight=='1080'?'1000px':'700px', // Adjust this value as needed
  },
  root: {
    flexGrow: 1,
    marginTop:"-3vh"
  },
  card: {
    padding: theme.spacing(2),
    textAlign: 'center',
    // color: theme.palette.text.secondary,
  }, papereg: {
    width:"5vh",
    height: '2vh',
    padding: theme.spacing(2),
    textAlign: 'center',
    // color: theme.palette.text.secondary,
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    boxShadow: '0 4px 10px 5px rgba(0, 0, 0, 0.1)',
    backgroundColor: 'white',
    borderRadius: '6px',
    height: '50vh',
    marginTop:"1vh"
  },
  alertspaper: {
    background:"#FFFFFF 0% 0% no-repeat padding-box",
    // boxShadow: '0px 4px 20px #0123B41A;',
    // backgroundColor: 'white',
    boxShadow:"1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
    backgroundColor:"#Fefefa",
    // opacity:"1",
    padding: theme.spacing(1),
    textAlign: 'center',
    // color: theme.palette.text.secondary,
    borderRadius: '6px',
    height: '16vh',
    marginTop:"1vh"
  },
  paper1: {
    padding: theme.spacing(2),
    textAlign: 'center',
    // color: theme.palette.text.secondary,
  },
  childpaper: {
    background:"#FFFFFF 0% 0% no-repeat padding-box",
    // boxShadow: '0px 4px 20px #0123B41A;',
    // backgroundColor: 'white',
    boxShadow:"1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
    backgroundColor:"#Fefefa",
    // opacity:"1",
    padding: theme.spacing(1),
    textAlign: 'center',
    // color: theme.palette.text.secondary,
    borderRadius: '6px',
  },
  graphpaper: {
    height: "26.25vh",
    padding: theme.spacing(1),
    textAlign: 'center',
    // color: theme.palette.text.secondary,
    background:"#FFFFFF 0% 0% no-repeat padding-box",
    // boxShadow: '0px 4px 20px #0123B41A;',
    // backgroundColor: 'white',
    boxShadow:"1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
    backgroundColor:"#Fefefa",
    // opacity:"1",
    borderRadius: '6px',
  },
  graphpaper1: {
    height: "19.25vh",
    padding: theme.spacing(1),
    textAlign: 'center',
    // color: theme.palette.text.secondary,
    background:"#FFFFFF 0% 0% no-repeat padding-box",
    // boxShadow: '0px 4px 20px #0123B41A;',
    // backgroundColor: 'white',
    boxShadow:"1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
    backgroundColor:"#Fefefa",
    // opacity:"1",
    borderRadius: '6px',
  },
  select: {
    "&:after": {
      borderBottomColor: "blue",
    },
    "& .MuiSvgIcon-root": {
      color: "white",
      backgroundColor:"#0123b4",borderRadius:"8px"
    },
    "& .MuiSelect-root ": {
      marginTop:"-2vh"
    }
  },
  imagecard:{
    height: "68.25vh",
    padding: theme.spacing(1),
    textAlign: 'center',
    // color: theme.palette.text.secondary,
    background:"#FFFFFF 0% 0% no-repeat padding-box",
    // boxShadow: '0px 4px 20px #0123B41A;',
    // backgroundColor: 'white',
    boxShadow:"1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
    backgroundColor:"#Fefefa",
    // opacity:"1",
    borderRadius: '6px',
  },
  text: {
    fontSize: "14px",
    color: " #292929",
    fontFamily: "Arial"
  },
  control1: {
    width: "6vh",
    marginTop: "0vh",
    marginLeft: "-11vh",
    fontFamily: "Arial"
  },
  formControl: {
    autosize: true,
    clearable: false,
  },
  paper1: {
    padding: theme.spacing(1),
    textAlign: "center",
    // color: theme.palette.text.secondary,
  },
  datacards: {
    width: '100%',
    height: '13vh',
    margin: '1%',
    borderRadius: '0.8vw',
    boxShadow:"1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
    backgroundColor:"#Fefefa",   
  },
  semicircularbar:{
    height:"11vh",
    background:"#FFFFFF 0% 0% no-repeat padding-box",
    // boxShadow: '0px 4px 20px #0123B41A;',
    boxShadow:"1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
    backgroundColor:"#Fefefa",
    // opacity:"1",
    borderRadius: '6px',
  },
  semicircularbarcomp:{
    '@media (min-width:0px) and (max-width:599.95px)': {//xs
        marginTop:'-0.5vh',
        marginLeft:'-1.5vh'
      },
      '@media (min-width:600px) and (max-width:959.95px)': {//sm
        marginTop:'1vh',
        marginLeft:'-0.1vh'
      },
      '@media (min-width:960px) and (max-width:1279.95px)': {//md
        marginTop:'-1vh',
        marginLeft:'-1.1vh'
      },
      '@media (min-width:1280px) and (max-width:1919.95px)': {//lg
        marginTop:'0vh',
        marginLeft:'-0.1vh'
      },
      '@media (min-width:1920px) and (max-width:2559.95px)': {//xl
        marginTop:'1vh',
        marginLeft:'0.5vh'
      },
  },
  buttons: {
    font:'normal normal medium 16px/17px Bw Seido Round',
    color:'#FFFFFF',
    opacity:'1',
    width: '130%',
    height: '3.2vh',
    border: "none",
    cursor: "pointer",
    fontSize: "2vh",
    background:'#CE1E1E 0% 0% no-repeat padding-box;',
    borderRadius: "8px",
  },
  emptybuttons: {
    font:'normal normal medium 16px/17px Bw Seido Round',
    color:'grey',
    opacity:'1',
    width: '130%',
    height: '3.2vh',
    border: "none",
    cursor: "pointer",
    fontSize: "2vh",
    background:'rgb(239 229 229 / 87%)',
    borderRadius: "8px",
  },
  smallbuttons: {
    width: '29%',
    height: '3.2vh',
    backgroundColor: "rgb(239 229 229 / 87%)",
    border: "none",
    cursor: "pointer",
    fontSize: "2vh",
    borderRadius: "0.4vw",
    margin: '2%'
  },
  CardHeadFont:{
    '@media (min-width:0px) and (max-width:599.95px)': {//xs
      fontSize: "1.5vh",
      },
      '@media (min-width:600px) and (max-width:959.95px)': {//sm
        fontSize: "1.9vh",
        borderRadius:'10px'
      },
      '@media (min-width:960px) and (max-width:1279.95px)': {//md
        fontSize: "1.4vh",
      },
      '@media (min-width:1280px) and (max-width:1919.95px)': {//lg
        fontSize: "1.8vh",
      },
      '@media (min-width:1920px) and (max-width:2559.95px)': {//xl
        fontSize: "1.7vh",
      },
  },
}));

function getJSONElement(myJson, elementPath = []) {
  let eValue = myJson;
  for (let i = 0; i < elementPath.length; i++) {
    if (eValue !== undefined && eValue !== null) {
      eValue = eValue[elementPath[i]];

      // Check if the value is the string "NULL" and return null
      if (typeof eValue === 'string' && eValue.toUpperCase() === 'NULL') {
        return null;
      }
    } else {
      eValue = undefined;
      console.log(`Unable to process JSON: ${elementPath}`);
      break;
    }
  }
  return eValue !== undefined ? eValue : null;
}

export default function App(props) {
  const classes = useStyles();
  const mapRef = React.createRef()
  const alerts = useSelector(state => state.alarm.alarmData)
  const [eachChillerData, setEachChillerData] = React.useState([])
  const [eachHeaderData, setEachHeaderData] = React.useState({})
  const [eachCPMData, setEachCPMData] = React.useState({})
  const [criticalAlertsChiller, setcriticalAlertsChiller] = React.useState(0);
  const [soluAlertsChiller, setsoluAlertsChiller] = React.useState(0);
  const [criticalAlertsCoolT, setcriticalAlertsCoolT] = React.useState(0);
  const [soluAlertsCoolT, setsoluAlertsCoolT] = React.useState(0);
  const [criticalAlertsPP, setcriticalAlertsPP] = React.useState(0);
  const [soluAlertsPP, setsoluAlertsPP] = React.useState(0);
  const [criticalAlertsSP, setcriticalAlertsSP] = React.useState(0);
  const [soluAlertsSP, setsoluAlertsSP] = React.useState(0);
  const [criticalAlertsCondenser, setcriticalAlertsCondenser] = React.useState(0);
  const [soluAlertsCondenser, setsoluAlertsCondenser] = React.useState(0);
  ////////////////
  const [allFloorsAlarms, setAllFloorsAlarms] = React.useState(0);
  const [criticalAlarms, setCriticalAlarms] = React.useState(0);
  const [nonCriticalAlarms, setNonCriticalAlarms] = React.useState(0);
  ////////////////
  const [openerr,setOpenerr] = React.useState(false);
  const [errmsg,setErrmsg] = React.useState('');
  const [CWH_ST, setCWH_ST] = useState([]);
  const [CWH_RT, setCWH_RT] = useState([]);
  const [CWH_ST24Hr, setCWH_ST24Hr] = useState([]);
  const [CWH_RT24Hr, setCWH_RT24Hr] = useState([]);
  const [CndW_HST, setCndW_HST] = useState([]);
  const [CndW_HRT, setCndW_HRT] = useState([]);
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [pumpModal, setPumpModal] = useState(false);
  const [triggerModal, setTriggerModal] = useState(false);
  const [disable, setDisable] = useState(false);
  const [opn_SS, setOpn_SS] = useState(0);
  const [dpt1, setDPT1] = useState("");
  const [dpt2, setDPT2] = useState("");
  const [dpt3, setDPT3] = useState("");
  const [dpt4, setDPT4] = useState("");
  const [primaryPump, setPrimaryPump] = useState([]);
  const [pripAlerts, setPriPAlerts] = useState([]);
  const [secondaryPump, setSecondaryPump] = useState([]);
  const [secpAlerts, setSecPAlerts] = useState([]);
  const [coolingTowers, setCoolingTowers] = useState([]);
  const [ctAlerts, setCTAlerts] = useState([]);
  const [condensers, setCondensers] = useState([]);
  const [condenserAlerts, setCondenserAlerts] = useState([]);
  const [pumpType, setPumpType] = useState("");
  const [pumpData, setPumpData] = useState({});
  const [modalHeading, setModalHeading] = useState('Parameter');
  const [isHovered, setIsHovered] = useState(false);
  const [cpmres, setCPMRes] = useState('');
  const [cpmAutoManualStatus, setCpmAutoManualStatus] = useState(0);
  const [cpmSSType, setCpmSSType] = useState("");
  const [cpmid, setCpmid] = useState("");
  const [cpmCurrentStatedata, setCPMCurrentStateData] = useState({});
  let chillers= processDataFromJson == true ?  eachChillerData:Object.values(eachChillerData).sort(function(a,b) {return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);});
  let header= processDataFromJson == true ?  eachHeaderData:Object.values(eachHeaderData).sort(function(a,b) {return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);});
  let cpm= processDataFromJson == true ?  eachCPMData:Object.values(eachCPMData).sort(function(a,b) {return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);});
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const iconDevice1 = new Leaflet.Icon({
      iconUrl: require("../../assets/img/sensor-icon.png"),
      iconSize: new Leaflet.Point(0, 0),
      className: "leaflet-div-icon-2",
    });
  const iconDevice2 = new Leaflet.Icon({
      iconUrl: require("../../assets/img/Green_dot_blink.gif"),
      iconSize: new Leaflet.Point(30, 30),
      className: "leaflet-div-icon-2",
    });
  const options = [
    {
      selectedFontColor: "white",
      label: "OFF",
      value: 0,
      selectedBackgroundColor: grayColor[0],
    },
    {
      selectedFontColor: "white",
      label: "ON",
      value: 1,
      selectedBackgroundColor: greenColor[0],
    },
    // {
    //   selectedFontColor: "white",
    //   label: "Off",
    //   value: 1,
    //   selectedBackgroundColor: "red",
    // },
    // {
    //   selectedFontColor: "white",
    //   label: "AUTO",
    //   value: 2,
    //   selectedBackgroundColor: "orange",
    // },
  ];

  const options2 = [
      {
        label: "OFF",
        value: 0,
        selectedBackgroundColor: grayColor[0],
        // fontSize:"2"
  
      },
      {
        label: "ON",
        value: 1,
        selectedBackgroundColor: greenColor[0],
        // fontSize:"2"
      },
    ];
  


  const initialSelectedIndex = options.findIndex(
    ({ value }) => value === "Manual"
  );


  const onClickEachCT=(data)=>{
    props.history.push({
      pathname: `/admin/GlCoolingTower`,
      state: {
        data: data
      }
    });
  }

  const onClickPump=(type,data)=>{
 props.history.push({
      pathname: `/admin/GlPrimaryPump`,
      state: {
        click: 'heading',
        type: type,
        data: data
      }
    });
  }

  const onClickEachPump=(name,data)=>{
    setPumpModal(true)
    setPumpType(name)
    setPumpData(data)
  }

  const handleClick = (data) => {
      console.log("single Click")
      setModalHeading(data)
      setModal(true)  
  }

  const handleDoubleClick = () => {
    console.log("Double Click")
    // setModalHeading(data)
    setModal2(true)  
}
  
  const handleClose = () => {
    setPumpModal(false)
    setModal(false);
    setTriggerModal(false)
  };

  const handleClose2 = () => {
    setModal2(false);
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
    setModal2(true)  
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleerrorclose = () => {
    setOpenerr(false);
    setErrmsg('');
  };
  const onClickTriggerIcon=(data)=>{
    setTriggerModal(true)
  }

  const onClickOfTrigger = (data) => {
    let req={}
    if(data == 'start'){
      req={"startCPMScenario":"START_CHILLER_SYSTEM"}
    }else if(data=='updates'){
      req={}
    }
    api.floor.startCPMTrigger(req).then((response)=>{
        if(response !== null && response!== undefined && response.data!== null &&  response.data!=undefined){
          // console.log("api res",response.data)

          setCPMRes(JSON.stringify(response.data,null,' '))
      }
    })
    .catch((error)=>{
        console.log("api err",error) 
      setCPMRes(error)
    })
  };

  const DeviceAlarms = (response,devicetype) => {
    let respp = Object.values(response).sort(function(a,b) {return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);});
    if (response.length !== 0) {
      let sdevices = []
      let CriticalTotal = 0
      let solutionTotal = 0
      if (alerts.system.length === 0 && alerts.solution.length === 0) {
        let con = 0
        respp.map(element => {
          let obj = {}
          con++
          obj["name"] = element.name
          obj["id"] = element.id
          obj["type"] = element.type
          obj["Eqp_Attributes"] = element["Eqp_Attributes"]
          obj["Eqp_Metrics"] = element["Eqp_Metrics"]
          obj["alerts_cri"] = 0
          obj["alerts_solu"] = 0
          sdevices.push(obj)
          if (respp.length === con) {
            if(devicetype=="Chillers")setEachChillerData(sdevices)
            if(devicetype=="Primary Pumps")setPriPAlerts(sdevices)
            if(devicetype=="Secondary Pumps")setSecPAlerts(sdevices)
            if(devicetype=="Condenser Pumps")setCondenserAlerts(sdevices)
            if(devicetype=="Cooling Towers")setCTAlerts(sdevices)
          }
          return element
        })
      }

      if (alerts.system.length > 0 && alerts.solution.length > 0) {
        respp.map(element => {
          let obj = {}
          obj["name"] = element.name
          obj["id"] = element.id
          obj["type"] = element.type
          obj["Eqp_Attributes"] = element["Eqp_Attributes"]
          obj["Eqp_Metrics"] = element["Eqp_Metrics"]
          let count = 0
          let ci = 0
          Object.keys(alerts.locationWise).forEach(key => {
            if (key === element.Equipment_Group) {
              setAllFloorsAlarms(alerts.locationWise[key].total_alarms)
              setCriticalAlarms(alerts.locationWise[key].critical)
              setNonCriticalAlarms(alerts.locationWise[key].nonCritical)
            }})

          alerts.system.map(ele => {
            if (element.id === ele.device_id) {
              count++
              ci++
              CriticalTotal++
              if (alerts.system.length === count) {
                obj["alerts_cri"] = ci
                  // if(devicetype=="Chillers")setcriticalAlertsChiller(CriticalTotal)
                  // if(devicetype=="Primary Pumps")setcriticalAlertsPP(CriticalTotal)
                  // if(devicetype=="Secondary Pumps")setcriticalAlertsSP(CriticalTotal)
                  // if(devicetype=="Condenser Pumps")setcriticalAlertsCondenser(CriticalTotal)
                  // if(devicetype=="Cooling Towers")setcriticalAlertsCoolT(CriticalTotal)
                let si = 0
                let counts = 0
                alerts.solution.map(ele1 => {
                  if (element.name === ele1.device_name) {
                    counts++
                    si++
                    solutionTotal++
                    if (alerts.solution.length === counts) {
                      obj["alerts_solu"] = si
                      sdevices.push(obj)
                      if(devicetype=="Chillers"){
                        // setsoluAlertsChiller(solutionTotal)
                        setEachChillerData(sdevices)
                      }
                      if(devicetype=="Primary Pumps"){
                        // setsoluAlertsPP(solutionTotal)
                        setPriPAlerts(sdevices)
                      }
                      if(devicetype=="Secondary Pumps"){
                        // setsoluAlertsSP(solutionTotal)
                        setSecPAlerts(sdevices)
                      }
                      if(devicetype=="Condenser Pumps"){
                        // setsoluAlertsCondenser(solutionTotal)
                        setCondenserAlerts(sdevices)
                      }
                      if(devicetype=="Cooling Towers"){
                        // setsoluAlertsCoolT(solutionTotal)
                        setCTAlerts(sdevices)
                      }
                    }
                  } else {
                    counts++
                    if (alerts.solution.length === counts) {
                      obj["alerts_solu"] = si
                      sdevices.push(obj)
                      if(devicetype=="Chillers"){
                        // setsoluAlertsChiller(solutionTotal)
                        setEachChillerData(sdevices)
                      }
                      if(devicetype=="Primary Pumps"){
                        // setsoluAlertsPP(solutionTotal)
                        setPriPAlerts(sdevices)
                      }
                      if(devicetype=="Secondary Pumps"){
                        // setsoluAlertsSP(solutionTotal)
                        setSecPAlerts(sdevices)
                      }
                      if(devicetype=="Condenser Pumps"){
                        // setsoluAlertsCondenser(solutionTotal)
                        setCondenserAlerts(sdevices)
                      }
                      if(devicetype=="Cooling Towers"){
                        // setsoluAlertsCoolT(solutionTotal)
                        setCTAlerts(sdevices)
                      }
                    }
                  }
                  return ele1
                })

              }
            } else {
              count++
              if (alerts.system.length === count) {
                obj["alerts_cri"] = ci
                // if(devicetype=="Chillers")setcriticalAlertsChiller(CriticalTotal)
                // if(devicetype=="Primary Pumps")setcriticalAlertsPP(CriticalTotal)
                // if(devicetype=="Secondary Pumps")setcriticalAlertsSP(CriticalTotal)
                // if(devicetype=="Condenser Pumps")setcriticalAlertsCondenser(CriticalTotal)
                // if(devicetype=="Cooling Towers")setcriticalAlertsCoolT(CriticalTotal)
                let si = 0
                let counts = 0
                alerts.solution.map(ele => {
                  if (element.id === ele.device_id) {
                    counts++
                    si++
                    solutionTotal++
                    if (alerts.solution.length === counts) {
                      obj["alerts_solu"] = si
                      sdevices.push(obj)
                      if(devicetype=="Chillers"){
                        // setsoluAlertsChiller(solutionTotal)
                        setEachChillerData(sdevices)
                      }
                      if(devicetype=="Primary Pumps"){
                        // setsoluAlertsPP(solutionTotal)
                        setPriPAlerts(sdevices)
                      }
                      if(devicetype=="Secondary Pumps"){
                        // setsoluAlertsSP(solutionTotal)
                        setSecPAlerts(sdevices)
                      }
                      if(devicetype=="Condenser Pumps"){
                        // setsoluAlertsCondenser(solutionTotal)
                        setCondenserAlerts(sdevices)
                      }
                      if(devicetype=="Cooling Towers"){
                        // setsoluAlertsCoolT(solutionTotal)
                        setCTAlerts(sdevices)
                      }
                    }
                  } else {
                    counts++
                    if (alerts.solution.length === counts) {
                      obj["alerts_solu"] = si
                      sdevices.push(obj)
                      if(devicetype=="Chillers"){
                        // setsoluAlertsChiller(solutionTotal)
                        setEachChillerData(sdevices)
                      }
                      if(devicetype=="Primary Pumps"){
                        // setsoluAlertsPP(solutionTotal)
                        setPriPAlerts(sdevices)
                      }
                      if(devicetype=="Secondary Pumps"){
                        // setsoluAlertsSP(solutionTotal)
                        setSecPAlerts(sdevices)
                      }
                      if(devicetype=="Condenser Pumps"){
                        // setsoluAlertsCondenser(solutionTotal)
                        setCondenserAlerts(sdevices)
                      }
                      if(devicetype=="Cooling Towers"){
                        // setsoluAlertsCoolT(solutionTotal)
                        setCTAlerts(sdevices)
                      }
                    }
                  }
                  return ele
                })
              }
            }
            return ele
          })
          return element
        })
      }

      if (alerts.system.length > 0 && alerts.solution.length === 0) {
        respp.map(element => {
          let obj = {}
          obj["name"] = element.name
          obj["id"] = element.id
          obj["type"] = element.type
          obj["Eqp_Attributes"] = element["Eqp_Attributes"]
          obj["Eqp_Metrics"] = element["Eqp_Metrics"]
          let count = 0
          let ci = 0

          Object.keys(alerts.locationWise).forEach(key => {
            if (key === element.Equipment_Group) {
              setAllFloorsAlarms(alerts.locationWise[key].total_alarms)
              setCriticalAlarms(alerts.locationWise[key].critical)
              setNonCriticalAlarms(alerts.locationWise[key].nonCritical)
            }})

          alerts.system.map(ele => {
            if (element.id === ele.device_id) {
              count++
              ci++
              CriticalTotal++
              if (alerts.system.length === count) {
                obj["alerts_cri"] = ci
                obj["alerts_solu"] = 0
                // if(devicetype=="Chillers")setcriticalAlertsChiller(CriticalTotal)
                // if(devicetype=="Primary Pumps")setcriticalAlertsPP(CriticalTotal)
                // if(devicetype=="Secondary Pumps")setcriticalAlertsSP(CriticalTotal)
                // if(devicetype=="Condenser Pumps")setcriticalAlertsCondenser(CriticalTotal)
                // if(devicetype=="Cooling Towers")setcriticalAlertsCoolT(CriticalTotal)
                  sdevices.push(obj)
                if(devicetype=="Chillers")setEachChillerData(sdevices)
                if(devicetype=="Primary Pumps")setPriPAlerts(sdevices)          
                if(devicetype=="Secondary Pumps")setSecPAlerts(sdevices)          
                if(devicetype=="Condenser Pumps")setCondenserAlerts(sdevices)          
                if(devicetype=="Cooling Towers")setCTAlerts(sdevices)          
                    }
            } else {
              count++
              if (alerts.system.length === count) {
                obj["alerts_cri"] = ci
                obj["alerts_solu"] = 0
                  // if(devicetype=="Chillers")setcriticalAlertsChiller(CriticalTotal)
                  // if(devicetype=="Primary Pumps")setcriticalAlertsPP(CriticalTotal)
                  // if(devicetype=="Secondary Pumps")setcriticalAlertsSP(CriticalTotal)
                  // if(devicetype=="Condenser Pumps")setcriticalAlertsCondenser(CriticalTotal)
                  // if(devicetype=="Cooling Towers")setcriticalAlertsCoolT(CriticalTotal)
                sdevices.push(obj)
                if(devicetype=="Chillers")setEachChillerData(sdevices)
                if(devicetype=="Primary Pumps")setPriPAlerts(sdevices)       
                if(devicetype=="Secondary Pumps")setSecPAlerts(sdevices)       
                if(devicetype=="Condenser Pumps")setCondenserAlerts(sdevices)       
                if(devicetype=="Cooling Towers")setCTAlerts(sdevices)       
                       }
            }
            return ele
          })
          return element
        })


      }

      if (alerts.system.length === 0 && alerts.solution.length > 0) {
        respp.map(element => {
          let obj = {}
          obj["name"] = element.name
          obj["id"] = element.id
          obj["type"] = element.type
          obj["Eqp_Attributes"] = element["Eqp_Attributes"]
          obj["Eqp_Metrics"] = element["Eqp_Metrics"]
          let count = 0
          let ci = 0

          Object.keys(alerts.locationWise).forEach(key => {
            if (key === element.Equipment_Group) {
              setAllFloorsAlarms(alerts.locationWise[key].total_alarms)
              setCriticalAlarms(alerts.locationWise[key].critical)
              setNonCriticalAlarms(alerts.locationWise[key].nonCritical)
            }})

          alerts.solution.map(ele => {
            if (element.id === ele.device_id) {
              count++
              ci++
              solutionTotal++
              if (alerts.solution.length === count) {
                obj["alerts_solu"] = ci
                obj["alerts_cri"] = 0
                sdevices.push(obj)
                if(devicetype=="Chillers")
                  {
                    // setsoluAlertsChiller(solutionTotal)
                    setEachChillerData(sdevices)
                  }
                if(devicetype=="Primary Pumps"){
                  // setsoluAlertsPP(solutionTotal)
                  setPriPAlerts(sdevices)
                }
                if(devicetype=="Secondary Pumps"){
                  // setsoluAlertsSP(solutionTotal)
                  setSecPAlerts(sdevices)
                }
                if(devicetype=="Condenser Pumps"){
                  // setsoluAlertsCondenser(solutionTotal)
                  setCondenserAlerts(sdevices)
                }
                if(devicetype=="Cooling Towers"){
                  // setsoluAlertsCoolT(solutionTotal)
                  setCTAlerts(sdevices)
                }
              }
            } else {
              count++
              if (alerts.solution.length === count) {
                obj["alerts_solu"] = ci
                obj["alerts_cri"] = 0
                sdevices.push(obj)
                if(devicetype=="Chillers"){
                  // setsoluAlertsChiller(solutionTotal)
                  setEachChillerData(sdevices)
                }
                if(devicetype=="Primary Pumps"){
                  // setsoluAlertsPP(solutionTotal)
                  setPriPAlerts(sdevices)
                }
                if(devicetype=="Secondary Pumps"){
                  // setsoluAlertsSP(solutionTotal)
                  setSecPAlerts(sdevices)
                }  
                if(devicetype=="Condenser Pumps"){
                  // setsoluAlertsCondenser(solutionTotal)
                  setCondenserAlerts(sdevices)
                }  
                if(devicetype=="Cooling Towers"){
                  // setsoluAlertsCoolT(solutionTotal)
                  setCTAlerts(sdevices)
                }  
                            }
            }
            return ele
          })
          return element
        })
      }

    }
    else {
      // if(devicetype=="Chillers")
        setEachChillerData([])
      // if(devicetype=="Primary Pumps")
        setPriPAlerts([])
      // if(devicetype=="Secondary Pumps")
        setSecPAlerts([])
      // if(devicetype=="Condenser Pumps")
        setCondenserAlerts([])
      // if(devicetype=="Cooling Towers")
        setCTAlerts([])
    }
  }

   const onChangeSEQpanel = (newValue) => {
        setDisable(true)
        setTimeout(() => { setDisable(false) }, 30000);
        setOpn_SS(newValue)
  
          const req={
              "ss_type":"NONGL_SS_CPM",
              "ss_id":"92b489c2-ebb8-4cc8-8c34-c1caec2ef2c9",
              "gl_command": newValue == 0? "TURN_OFF" :newValue == 1?"TURN_ON" :"AUTO",
               "value": newValue === 1 ? "On" : newValue === 0 ? "Off" : "Auto",
              "param_id": "PP_Seq_Pnl_Cmd",
              "zone_type":null,
              "zone_id":null,
              "commandFrom":"UI",
          }
          api.floor.cpmOnOffControl(req).then((response)=>{   
                    toast({
                          type:"info",
                          icon:"check circle",
                          // title:"Success",
                          description: response,
                          time: 3000,
                        })
              
          })
          .catch((err)=>{
              setOpenerr(true)
              setErrmsg(err)          
          })
        };

  useEffect(()=>{
    // api.floor.cpmgetStatus().then((res) =>{
    //   if(res){
    //     localStorage.setItem("CPM_AM_Status",res.Mode == 'Auto'?true:false)
    //     setCpmAutoManualStatus(res.Mode == 'Manual'? 0:1)
    //   }
    // })
    // .catch((error)=>{
    //   if(error.response){
    //     setErrmsg(error.response.data.message)
    //     setOpenerr(true)
    //   }else{
    //     setErrmsg('')
    //   }
    // })

    api.floor.cpmGetDevData().then((res)=>{
      if(res["NONGL_SS_CPM"]){
        const firstObj = res["NONGL_SS_CPM"];
        let CPM_Stat = (firstObj[Object.keys(res.NONGL_SS_CPM)].Eqp_Metrics.Equipment_GL_CPM_MODE);
        setCpmAutoManualStatus((CPM_Stat==true)? 1:0)
        setCpmSSType("NONGL_SS_CPM")
        setCpmid(firstObj[Object.keys(res.NONGL_SS_CPM)].id)
        localStorage.setItem("CPM_AM_Status",CPM_Stat)
      }
      if(res["NONGL_SS_AIR_COOLED_HEADER"]){
        setEachHeaderData(Object.values(res["NONGL_SS_AIR_COOLED_HEADER"]))
        const firstObject = res["NONGL_SS_AIR_COOLED_HEADER"];
      if(firstObject[Object.keys(res.NONGL_SS_AIR_COOLED_HEADER)].id != undefined){

      api.floor.getDeviceData(firstObject[Object.keys(res.NONGL_SS_AIR_COOLED_HEADER)].id,'NONGL_SS_COMMON_HEADER',"1 HOUR").then((res)=>{
        if(res.graphData.length){
          if(res.graphData[0]['CWH_ST']){
              setCWH_ST(res.graphData[0]['CWH_ST'])
          }
          if(res.graphData[0]['CWH_RT']){
            // console.log("res.graphData[0]['CWH_RT']",res.graphData[0]['CWH_RT'])
            setCWH_RT(res.graphData[0]['CWH_RT'])
        }
        
        }
      }).catch((error)=>{
        if(error.response){
            // setOpenerr(true)
            setErrmsg(error.response.data.message)
            }else{
              setErrmsg('')
            }
      })

      api.floor.getDeviceData(firstObject[Object.keys(res.NONGL_SS_AIR_COOLED_HEADER)].id,'NONGL_SS_COMMON_HEADER',"1 DAY").then((res)=>{
        if(res.graphData.length){
          if(res.graphData[0]['CWH_ST']){
              setCWH_ST24Hr(res.graphData[0]['CWH_ST'])
          }
          if(res.graphData[0]['CWH_RT']){
            // console.log("res.graphData[0]['CWH_RT']",res.graphData[0]['CWH_RT'])
            setCWH_RT24Hr(res.graphData[0]['CWH_RT'])
        }
        
        }
      }).catch((error)=>{
        if(error.response){
            // setOpenerr(true)
            setErrmsg(error.response.data.message)
            }else{
              setErrmsg('')
            }
      })
    }
      }
      if(res["NONGL_SS_AIR_COOLED_CHILLER"]){
        let respp = Object.values(res["NONGL_SS_AIR_COOLED_CHILLER"]).sort(function(a,b) {return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);});
        respp.map(element => {
          if(element.id == "9e23dddb-544e-48a3-9c3d-524579e58f0d"){
            setDPT1(element.Eqp_Attributes.CH_DPT.presentValue)
          }
          if(element.id == "a0ad130c-e042-4fc4-9b67-28cb78216bfd"){
            setDPT2(element.Eqp_Attributes.CH_DPT.presentValue)
          }
          if(element.id == "d718ffb0-2add-4022-914d-6adac9dd05be"){
            setDPT3(element.Eqp_Attributes.CH_DPT.presentValue)
          }
          if(element.id == "056b62a1-a7f6-4e46-be3a-badfc5c29db8"){
            setDPT4(element.Eqp_Attributes.CH_DPT.presentValue)
          }
          // console.log("acccccccccccccc------",element)
        })
      }
      DeviceAlarms(res["NONGL_SS_AIR_COOLED_CHILLER"],"Chillers")
      DeviceAlarms(res["NONGL_SS_PRIMARY_VARIABLE_PUMPS"],"Primary Pumps")
      DeviceAlarms(res["NONGL_SS_SECONDARY_PUMPS"],"Secondary Pumps")
      DeviceAlarms(res["NONGL_SS_CONDENSER_PUMPS"],"Condenser Pumps")
      DeviceAlarms(res["NONGL_SS_COOLING_TOWER"],"Cooling Towers")
    })
    .catch((error)=>{
      if(error.response){
        setErrmsg(error.response.data.message)
        // setOpenerr(true)
      }else{
        setErrmsg('')
      }
    })
    api.floor.cpmCurrentState().then((res)=>{
      setCPMCurrentStateData(res)
    })
    .catch((error)=>{
      if(error.response){
        setErrmsg(error.response.data.message)
        // setOpenerr(true)
      }else{
        setErrmsg('')
      }
    })
  
  const timer = setInterval(() => { 
    api.floor.cpmCurrentState().then((res)=>{
      setCPMCurrentStateData(res)
    })
    .catch((error)=>{
      if(error.response){
        setErrmsg(error.response.data.message)
        // setOpenerr(true)
      }else{
        setErrmsg('')
      }
    }) 
    // api.floor.cpmgetStatus().then((res) =>{
    //   if(res){
    //     localStorage.setItem("CPM_AM_Status",res.Mode == 'Auto'?true:false)
    //     setCpmAutoManualStatus(res.Mode == 'Manual'? 0:1)
    //   }
    // }).catch((error)=>{
    //   if(error.response){
    //     setErrmsg(error.response.data.message)
    //     // setOpenerr(true)
    //   }else{
    //     setErrmsg('')
    //   }
    // })
    api.floor.cpmGetDevData().then((res)=>{
      DeviceAlarms(res["NONGL_SS_AIR_COOLED_CHILLER"],"Chillers")
      if(res["NONGL_SS_CPM"]){
        const firstObj = res["NONGL_SS_CPM"];
        let CPM_Stat=(firstObj[Object.keys(res.NONGL_SS_CPM)].Eqp_Metrics.Equipment_GL_CPM_MODE)
        localStorage.setItem("CPM_AM_Status",CPM_Stat)
        setCpmAutoManualStatus((CPM_Stat==true)? 1:0)
        setCpmSSType("NONGL_SS_CPM")
        setCpmid(firstObj[Object.keys(res.NONGL_SS_CPM)].id)}
      if(res["NONGL_SS_AIR_COOLED_HEADER"]){
        setEachHeaderData(Object.values(res["NONGL_SS_AIR_COOLED_HEADER"]))
        const firstObject = res["NONGL_SS_AIR_COOLED_HEADER"];
      if(firstObject[Object.keys(res.NONGL_SS_AIR_COOLED_HEADER)].id != undefined){

      api.floor.getDeviceData(firstObject[Object.keys(res.NONGL_SS_AIR_COOLED_HEADER)].id,'NONGL_SS_COMMON_HEADER',"1 HOUR").then((res)=>{
        if(res.graphData.length){
          if(res.graphData[0]['CWH_ST']){
              setCWH_ST(res.graphData[0]['CWH_ST'])
          }
          if(res.graphData[0]['CWH_RT']){
            // console.log("res.graphData[0]['CWH_RT']",res.graphData[0]['CWH_RT'])
            setCWH_RT(res.graphData[0]['CWH_RT'])
        }
        
        }
      }).catch((error)=>{
        if(error.response){
            // setOpenerr(true)
            setErrmsg(error.response.data.message)
            }else{
              setErrmsg('')
            }
      })

      api.floor.getDeviceData(firstObject[Object.keys(res.NONGL_SS_AIR_COOLED_HEADER)].id,'NONGL_SS_COMMON_HEADER',"1 DAY").then((res)=>{
        if(res.graphData.length){
          if(res.graphData[0]['CWH_ST']){
              setCWH_ST24Hr(res.graphData[0]['CWH_ST'])
          }
          if(res.graphData[0]['CWH_RT']){
            // console.log("res.graphData[0]['CWH_RT']",res.graphData[0]['CWH_RT'])
            setCWH_RT24Hr(res.graphData[0]['CWH_RT'])
        }
        
        }
      }).catch((error)=>{
        if(error.response){
            // setOpenerr(true)
            setErrmsg(error.response.data.message)
            }else{
              setErrmsg('')
            }
      })
    }
      }
      if(res["NONGL_SS_CPM"]){
        setEachCPMData(Object.values(res["NONGL_SS_CPM"]))
        let cpmdataArr = Object.values(res["NONGL_SS_CPM"])
        Object.values(cpmdataArr).map((res)=>{
          setOpn_SS(res['Eqp_Attributes']['PP_Seq_Pnl_Cmd'].presentValue == 'active'? 1:0)
        })
      }
      DeviceAlarms(res["NONGL_SS_COOLING_TOWER"],"Cooling Towers")
      DeviceAlarms(res["NONGL_SS_PRIMARY_VARIABLE_PUMPS"],"Primary Pumps")
      DeviceAlarms(res["NONGL_SS_SECONDARY_PUMPS"],"Secondary Pumps")
      DeviceAlarms(res["NONGL_SS_CONDENSER_PUMPS"],"Condenser Pumps")

      if(res["NONGL_SS_PRIMARY_VARIABLE_PUMPS"]){
        setPrimaryPump(res["NONGL_SS_PRIMARY_VARIABLE_PUMPS"])
      }
      if(res["NONGL_SS_SECONDARY_PUMPS"]){
        setSecondaryPump(res["NONGL_SS_SECONDARY_PUMPS"])
      }
      if(res["NONGL_SS_CONDENSER_PUMPS"]){
        setCondensers(res["NONGL_SS_CONDENSER_PUMPS"])
      }
      if(res["NONGL_SS_COOLING_TOWER"]){
        setCoolingTowers(res["NONGL_SS_COOLING_TOWER"])
      }
    })
    .catch((error)=>{
      if(error.response){
        setErrmsg(error.response.data.message)
        // setOpenerr(true)
      }else{
        setErrmsg('')
      }
    })
   }, 3000);
  return () => clearInterval(timer);
  },[alerts.systemCount,alerts.solutionCount])

  useEffect(()=>{
    // api.floor.cpmGetDevData().then((res)=>{
    //   const firstObject = res["NONGL_SS_AIR_COOLED_HEADER"];
    //   if(firstObject[Object.keys(res.NONGL_SS_AIR_COOLED_HEADER)].id != undefined){
    //   api.floor.getDeviceData(firstObject[Object.keys(res.NONGL_SS_AIR_COOLED_HEADER)].id,'NONGL_SS_COMMON_HEADER',"1 HOUR").then((res)=>{
    //     if(res.graphData.length){
    //       if(res.graphData[0]['CWH_ST']){
    //           setCWH_ST(res.graphData[0]['CWH_ST'])
    //       }
    //       if(res.graphData[0]['CWH_RT']){
    //         // console.log("res.graphData[0]['CWH_RT']",res.graphData[0]['CWH_RT'])
    //         setCWH_RT(res.graphData[0]['CWH_RT'])
    //     }
        
    //     }
    //   }).catch((error)=>{
    //     if(error.response){
    //         // setOpenerr(true)
    //         setErrmsg(error.response.data.message)
    //         }else{
    //           setErrmsg('')
    //         }
    //   })
    // }
    // }) 
    // const timer1 = setInterval(() => { 
    //   api.floor.cpmGetDevData().then((res)=>{
    //     const firstObject = res["NONGL_SS_AIR_COOLED_HEADER"];
    //     if(firstObject[Object.keys(res.NONGL_SS_AIR_COOLED_HEADER)].id != undefined){
    //     api.floor.getDeviceData(firstObject[Object.keys(res.NONGL_SS_AIR_COOLED_HEADER)].id,'NONGL_SS_COMMON_HEADER',"1 HOUR").then((res)=>{
    //       if(res.graphData.length){
    //         if(res.graphData[0]['CWH_ST']){
    //             setCWH_ST(res.graphData[0]['CWH_ST'])
    //         }
    //         if(res.graphData[0]['CWH_RT']){
    //           // console.log("res.graphData[0]['CWH_RT']",res.graphData[0]['CWH_RT'])
    //           setCWH_RT(res.graphData[0]['CWH_RT'])
    //       }
          
    //       }
    //     }).catch((error)=>{
    //       if(error.response){
    //           // setOpenerr(true)
    //           setErrmsg(error.response.data.message)
    //           }else{
    //             setErrmsg('')
    //           }
    //     })
    //   }
    //   })   
    // }, 3000);
    // return () => clearInterval(timer1);
  },[alerts.systemCount,alerts.solutionCount])

  const getBackgroundColor = (attributes) => {
    if (!attributes) return 'grey';
  
    
    if (attributes.CWH_ST) {
      const value = attributes.CWH_ST.presentValue;
      if (value === undefined || value === null) return 'grey';
      return value >= 0 && value <= 100 ? 'green' : 'red';
    }

    if (attributes.CWH_RT) {
      const value = attributes.CWH_RT.presentValue;
      if (value === undefined || value === null) return 'grey';
      return value >= 0 && value <= 100 ? 'green' : 'red';
    }
  
    if (attributes.DPT_H) {
      const value = attributes.DPT_H.presentValue;
      if (value === undefined || value === null) return 'grey';
      return value >= 0 && value <= 100 ? 'green' : 'red';
    }

    if (attributes.BYPASS_HEADER_VLV_FBK) {
      const value = attributes.BYPASS_HEADER_VLV_FBK.presentValue;
      if (value === undefined || value === null) return 'grey';
      return value >= 0 && value <= 100 ? 'green' : 'red';
    }

    if (attributes.dpt1) {
      const value = attributes.dpt1.presentValue;
      if (value === undefined || value === null) return 'grey';
      return value >= 0 && value <= 100 ? 'green' : 'red';
    }
  
    if (attributes.dpt2) {
      const value = attributes.dpt2.presentValue;
      if (value === undefined || value === null) return 'grey';
      return value >= 0 && value <= 100 ? 'green' : 'red';
    }
  

    if (attributes.dpt3) {
      const value = attributes.dpt3.presentValue;
      if (value === undefined || value === null) return 'grey';
      return value >= 0 && value <= 100 ? 'green' : 'red';
    }
  
    if (attributes.dpt4) {
      const value = attributes.dpt4.presentValue;
      if (value === undefined || value === null) return 'grey';
      return value >= 0 && value <= 100 ? 'green' : 'red';
    }
  
  
    return 'grey'; 
  };
  
  const getDisplayValue = (attributes) => {
    if (attributes?.CWH_ST) {
      return formatter.format(attributes.CWH_ST.presentValue) + '°C';
    }
    if (attributes?.DPT_H) {
      return formatter.format(attributes.DPT_H.presentValue);
    }
    return 'N/A';
  };
  
  

  const numEmptyCards = 19 - Object.entries(coolingTowers).length; // Adjust the total number as needed
  // Create an array of empty cards
  const emptyCardsForCT = Array.from({ length: numEmptyCards }, (_, index) => (    
  <button className={classes.smallbuttons} style={{backgroundColor:"rgb(239 229 229 / 87%)", color: 'white'}}></button>
  ));

  const numEmptyCardsForPriPumps = 6 - Object.entries(primaryPump).length; // Adjust the total number as needed
  const emptyCardsForPriPumps = Array.from({ length: numEmptyCardsForPriPumps }, (_, index) => (
    <button className={classes.smallbuttons} style={{ backgroundColor:"rgb(239 229 229 / 87%)", color: 'white'}}></button>
  ));


  const numEmptyCardsForSecPumps = 16 - Object.entries(secondaryPump).length; // Adjust the total number as needed

  const emptyCardsForSecPumps = Array.from({ length: numEmptyCardsForSecPumps }, (_, index) => (
    <button className={classes.smallbuttons} style={{ backgroundColor:"rgb(239 229 229 / 87%)", color: 'white'}}></button>
  ));

  const numEmptyCardsForCPumps = 6 - Object.entries(condensers).length; // Adjust the total number as needed

  const emptyCardsForCPumps = Array.from({ length: numEmptyCardsForCPumps }, (_, index) => (
    <button className={classes.smallbuttons} style={{ backgroundColor:"rgb(239 229 229 / 87%)", color: 'white'}}></button>
  ));

  const onChangeCPMStatus = (newValue) => {
    setCpmAutoManualStatus(newValue)
    let Equipment_GL_CPM_MODE =(newValue == 0 ? false: true)
    let ss_type = cpmSSType
    let id = cpmid
    let req={
      Equipment_GL_CPM_MODE,
      ss_type,
      id
    }
    if(ss_type && id)
    {api.floor.cpmControl(req).then((response)=>{
      console.log('api resppp',response,newValue)
      if(response){
        localStorage.setItem("CPM_AM_Status",newValue == 0 ? false: true)
        toast({
          type: "success",
          icon: "check circle",
          title: "Success",
          description: response,
          time: 2000,
        });
      }
    }).catch((error)=>{
      toast({
        type: "error",
        icon: "exclamation triangle",
        title: "Error",
        // description: response,
        time: 2000,
      });
    })
  }
  }
  return (
    <div className={classes.root}>
            <Snackbar open={openerr} autoHideDuration={6000} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
              <Alert style={{ cursor: "pointer" }} severity="error" variant="filled" onClose={handleerrorclose}>
                {errmsg}
              </Alert>
            </Snackbar>
            <Grid container item xs={12} spacing={1}>
                {/* Left-top part */}
                <Grid item xs={12} spacing={1} sm={12} md={9} lg={9} xl={9} xxl={9}>
                    <Grid container item xs={12} spacing={1}>
                      <LandingPage processDataFromJson={processDataFromJson} device={chillers} totalAlarms={alerts.systemCount+alerts.solutionCount} criticalAlerts={alerts.systemCount} soluAlerts={alerts.solutionCount} type="CPM" />
                    </Grid>     
                    <Grid container item xs={12} spacing={1} style={{marginTop:"2vh"}}>
                            <Grid item spacing={1} xs={12} sm={12} md={2} lg={2} xl={2} xxl={2}>
                                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} spacing={1} direction='column'>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                        <Box className={classes.childpaper} style={{height:window.innerHeight=='1280'?"20vh":'16.4vh'}}>
                                          <div className={classes.CardHeadFont} style={{marginTop: window.innerHeight=='1280'?"1vh":'-1vh',fontWeight:'bold',color:'black',cursor:'pointer'}} 
                                          // onClick={()=>onClickPump("PrimaryPump",primaryPump)}
                                          >Primary Pumps</div>
                                          <Grid container direction="row" style={{marginTop:'0.3vh'}}>
                                            {pripAlerts.map((element, index) =>
                                                  <StyledTooltip title={element.name} className={classes.tooltip} arrow>
                                                  <button className={classes.smallbuttons} style={{ backgroundColor:element[6]==true?"#FF0000":element[3]=='0'?"grey":element.alerts_cri>0?"#CE1E1E":element.alerts_solu>0?"#f2aa1a":element["Eqp_Attributes"]["Pump_Run_Feedback"]!= undefined?((element["Eqp_Attributes"]["Pump_Run_Feedback"]["presentValue"] == ("inactive"||0))?"grey":(element["Eqp_Attributes"]["Pump_Run_Feedback"]["presentValue"] == ("active"||1))?"#21ba45":"grey"):"grey",color:'white' }} onClick={()=>onClickEachPump("Primary Pump",element)}>{index+1}
                                                    {/* {processDataFromJson == true ?element[3]:element.name} */}
                                                    </button>
                                                  </StyledTooltip>
                                                  )}
                                                  {emptyCardsForPriPumps}
                                          </Grid>
                                        </Box>
                                    </Grid>
                                    {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}> */}
                                        {/* <Box className={classes.childpaper} style={{height:window.innerHeight=='1280'?"20vh":'34vh'}}> */}
                                          {/* <div className={classes.CardHeadFont} style={{marginTop: window.innerHeight=='1280'?"1vh":'-1vh',fontWeight:'bold',color:'black',cursor:'pointer'}}  */}
                                          {/* // onClick={()=>onClickPump("SecondaryPump",secondaryPump)} */}
                                          {/* >Secondary Pumps</div> */}
                                          {/* <Grid container spacing={1} style={{marginTop:'0.3vh'}}> */}
                                              {/* {secpAlerts.map((element, index) => */}
                                                      {/* // <StyledTooltip title={element.name} className={classes.tooltip} arrow> */}
                                                      {/* <button className={classes.smallbuttons} style={{ backgroundColor:element[6]==true?"#FF0000":element[3]=='0'?"grey":element.alerts_cri>0?"#CE1E1E":element.alerts_solu>0?"#f2aa1a":element["Eqp_Attributes"]["Sec_Pmp_Run_SS"]!=undefined?((element["Eqp_Attributes"]["Sec_Pmp_Run_SS"]["presentValue"] == ("inactive"||0))?"grey":(element["Eqp_Attributes"]["Sec_Pmp_Run_SS"]["presentValue"] == ("active"||1))?"#21ba45":"grey"):"grey",color:'white' }} onClick={()=>onClickEachPump("Secondary Pump",element)}>{index+1} */}
                                                        {/* {processDataFromJson == true ?element[3]:element.name} */}
                                                        {/* </button> */}
                                                      {/* // </StyledTooltip> */}
                                                {/* //  )} */}
                                                 {/* {emptyCardsForSecPumps} */}
                                          {/* </Grid> */}
                                        {/* </Box>                               */}
                                    {/* </Grid> */}
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={12} md={10} lg={10} xl={10} xxl={10}>
                                <Grid container item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} spacing={1} direction='column'>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                        <Card className={classes.imagecard} style={{backgroundColor:'#E5E5E5'}}>
                                              <Map
                                                    ref={mapRef}
                                                    doubleClickZoom={false}
                                                    zoomControl={false}
                                                    dragging={false}
                                                    scrollWheelZoom={false}
                                                    crs={Leaflet.CRS.Simple}
                                                    center={[0, 0]}
                                                    attributionControl={false}
                                                    // bounds={[[0, 0], [600, 730]]}
                                                    bounds={[[0, 0], [470, 600]]}
                                                    // bounds={[[0, 0], [420, 600]]}
                                                    className={"floor-map"}
                                                    // style={{marginLeft:'-1vh',marginTop:'-1vh',width:"89vh",height:'67.5vh',}}
                                                    // style={{backgroundColor:"white"}}
                                                    onClick={(e) => { console.log({ x: e.latlng.lat, y: e.latlng.lng }) }}
                                                  >
                                                    <ImageOverlay
                                                      interactive
                                                      // url={'https://localhost/' + image + '.png'}
                                                      url={image}
                                                      // bounds={[[50, 15], [600, 730]]}
                                                      // bounds={[[100, -8], [525, 640]]}
                                                      // bounds={[[0, 0], [470, 590]]}
                                                      // bounds={[[0, 10], [470, 590]]}
                                                      bounds={[[20, 10], [430, 600]]}
                                                    />                                            
                                                    <ZoomControl position="bottomright" />
                                                    
                                                    {header.length>0?
                                                    <>{header.map((res)=>(<>
                                                    <Marker position={[97.25,209.24]} icon={iconDevice1}>
                                                    <Tooltip direction='right' opacity={0.75} permanent>
                                                      <div>
                                                        <span className={classes.Leaflet_Tooltip_Heading}>
                                                          CW Header <br />Return Temp
                                                        </span>
                                                        <br />
                                                        <div
                                                          className={classes.Leaflet_Tooltip_Values}
                                                          style={{ backgroundColor: getBackgroundColor(res?.Eqp_Attributes),color:'white' }}
                                                        >{formatter.format(res['Eqp_Attributes']['CWH_RT'].presentValue)+'°C'}
                                                        </div>
                                                      </div>{" "}
                                                    </Tooltip>
                                                  </Marker>                                                    
                                                  <Marker position={[106.69,149.20]} icon={iconDevice1}>
                                                    <Tooltip direction='left' opacity={0.75} permanent>
                                                      <div>
                                                        <span className={classes.Leaflet_Tooltip_Heading}>
                                                          CW Header <br />Supply Temp
                                                        </span>
                                                        <br />
                                                        <div
                                                          className={classes.Leaflet_Tooltip_Values}
                                                          style={{ backgroundColor: getBackgroundColor(res?.Eqp_Attributes),color:'white' }}
                                                        >{formatter.format(res['Eqp_Attributes']['CWH_ST'].presentValue)+'°C'}
                                                        </div>
                                                      </div>{" "}
                                                    </Tooltip>
                                                  </Marker>       
                                                  <Marker position={[ 82.20,178.23]} icon={iconDevice1}>
                                                    <Tooltip direction='bottom' opacity={0.75} permanent>
                                                      <div>
                                                        <span className={classes.Leaflet_Tooltip_Heading}>
                                                        DPT Header
                                                        </span>
                                                        <br />
                                                        <div
                                                          className={classes.Leaflet_Tooltip_Values}
                                                          style={{ backgroundColor: getBackgroundColor(res?.Eqp_Attributes),color:'white' }}
                                                        >{formatter.format(res['Eqp_Attributes']['DPT_H'].presentValue)+ ' bar'}
                                                        </div>
                                                      </div>{" "}
                                                    </Tooltip>
                                                  </Marker> 
                                                  <Marker position={[304.03,416.38]} icon={iconDevice1}>
                                                    <Tooltip direction='right' opacity={0.75} permanent>
                                                      <div>
                                                        <span className={classes.Leaflet_Tooltip_Heading}>
                                                          Chiller-01 
                                                          {/* <br />DPT 1 */}
                                                        </span>
                                                        <br />
                                                        <div
                                                          className={classes.Leaflet_Tooltip_Values}
                                                          style={{ backgroundColor: getBackgroundColor(res?.Eqp_Attributes),color:'white' }}
                                                        >{formatter.format(dpt1)+' bar'}
                                                        </div>
                                                      </div>{" "}
                                                    </Tooltip>
                                                  </Marker> 
                                                  <Marker position={[ 375.15,415.38]} icon={iconDevice1}>
                                                    <Tooltip direction='right' opacity={0.75} permanent>
                                                      <div>
                                                        <span className={classes.Leaflet_Tooltip_Heading}>
                                                        Chiller-02 {/* DPT 2 */}
                                                        </span>
                                                        <br />
                                                        <div
                                                          className={classes.Leaflet_Tooltip_Values}
                                                          style={{ backgroundColor: getBackgroundColor(res?.Eqp_Attributes),color:'white' }}
                                                        >{formatter.format(dpt2)+' bar'}
                                                        </div>
                                                      </div>{" "}
                                                    </Tooltip>
                                                  </Marker> 
                                                  <Marker position={[ 307.84,245.26]} icon={iconDevice1}>
                                                    <Tooltip direction='right' opacity={0.75} permanent>
                                                      <div>
                                                        <span className={classes.Leaflet_Tooltip_Heading}>
                                                        Chiller-03 {/* DPT 3 */}
                                                        </span>
                                                        <br />
                                                        <div
                                                          className={classes.Leaflet_Tooltip_Values}
                                                          style={{ backgroundColor: getBackgroundColor(res?.Eqp_Attributes),color:'white' }}
                                                        >{formatter.format(dpt3)+' bar'}
                                                        </div>
                                                      </div>{" "}
                                                    </Tooltip>
                                                  </Marker> 
                                                  <Marker position={[ 375.15,252.27]} icon={iconDevice1}>
                                                    <Tooltip direction='right' opacity={0.75} permanent>
                                                      <div>
                                                        <span className={classes.Leaflet_Tooltip_Heading}>
                                                        Chiller-04 {/* DPT 4 */}
                                                        </span>
                                                        <br />
                                                        <div
                                                          className={classes.Leaflet_Tooltip_Values}
                                                          style={{ backgroundColor: getBackgroundColor(res?.Eqp_Attributes),color:'white' }}
                                                        >{formatter.format(dpt4)+' bar'}
                                                        </div>
                                                      </div>{" "}
                                                    </Tooltip>
                                                  </Marker> 
                                                    </>))}
                                                    </>:<></>}                                                   
                                                    {cpm.length>0?
                                                    <>{cpm.map((res)=>(<>                                                       
                                                  <Marker position={[105.28,371.35]} icon={iconDevice1}>
                                                    <Tooltip direction='right' opacity={0.65} permanent>
                                                      <div>
                                                        <span className={classes.Leaflet_Tooltip_Heading}>
                                                          Bypass <br />Valve Status
                                                        </span>
                                                        <br />
                                                        <div
                                                          className={classes.Leaflet_Tooltip_Values}
                                                          style={{ backgroundColor: getBackgroundColor(res?.Eqp_Attributes),color:'white' }}
                                                        >{formatter.format(res['Eqp_Attributes']['BYPASS_HEADER_VLV_FBK'].presentValue)+'%'}
                                                        </div>
                                                      </div>{" "}
                                                    </Tooltip>
                                                  </Marker>   
                                                    </>))}
                                                    </>:<></>}     
                                                    {(chillers.length>=0)?
                                                    (chillers.map((element, index) =>     
                                                    <>
                                                    {
                                                     ( 
                                                      // console.log('index',index,'element["Eqp_Attributes"]["Pump_Run_Feedback"]["presentValue"]',element["Eqp_Attributes"]["Pump_Run_Feedback"]["presentValue"])
                                                      ((index=='0')&&(element?.Eqp_Attributes?.CH_Run_SS?.presentValue ==  'active'))?
                                                      <Marker position={[331.99,389.05]} icon={iconDevice2}></Marker>:
                                                      ((index=='1')&&(element?.Eqp_Attributes?.CH_Run_SS?.presentValue ==  'active'))?
                                                      <Marker position={[414.36,381.05]} icon={iconDevice2}></Marker>:
                                                      ((index=='2')&&(element?.Eqp_Attributes?.CH_Run_SS?.presentValue ==  'active'))?
                                                      <Marker position={[328.93,221.16]} icon={iconDevice2}></Marker>:
                                                      ((index=='3')&&(element?.Eqp_Attributes?.CH_Run_SS?.presentValue ==  'active'))?
                                                      <Marker position={[410.36,225.16]} icon={iconDevice2}></Marker>
                                                         :
                                                         <></>
                                                        )
                                                    }
                                                    </>)):<></>} 
                                                    {(pripAlerts.length>=0)?
                                                    (pripAlerts.map((element, index) =>     
                                                    <>
                                                    {
                                                     ( 
                                                      // console.log('index',index,'element["Eqp_Attributes"]["Pump_Run_Feedback"]["presentValue"]',element["Eqp_Attributes"]["Pump_Run_Feedback"]["presentValue"])
                                                      ((index=='2')&&(element?.Eqp_Attributes?.Pump_Run_Feedback?.presentValue ==  'active'))?
                                                      <Marker position={[231.62,211.24]} icon={iconDevice2}></Marker>:
                                                      ((index=='1')&&(element?.Eqp_Attributes?.Pump_Run_Feedback?.presentValue ==  'active'))?
                                                      <Marker position={[231.62,257.27]} icon={iconDevice2}></Marker>:
                                                      ((index=='0')&&(element?.Eqp_Attributes?.Pump_Run_Feedback?.presentValue ==  'active'))?
                                                      <Marker position={[231.62,302.30]} icon={iconDevice2}></Marker>
                                                         :
                                                         <></>
                                                        )
                                                    }
                                                    </>)):<></>} 
                                              </Map>
                                        </Card>
                                    </Grid>
                                    {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}> */}
                                        {/* <Card className={classes.imagecard} style={{backgroundColor:'#E5E5E5',height:'4vh'}}> */}
                                        {/* <marquee width="100%" direction="left" height="100px">
                                            Current Scenario: {cpmCurrentStatedata.currentScenario? cpmCurrentStatedata.currentScenario: " - "} ,Current State: {cpmCurrentStatedata.currentState? cpmCurrentStatedata.currentState:" - "}
                                        </marquee> */}
                                        {/* <div style={{display:'flex',justifyContent:'center',alignItems:'center',whiteSpace:"nowrap"}}>Current Scenario: {cpmCurrentStatedata.currentScenario? cpmCurrentStatedata.currentScenario: " - "} ,Current State: {cpmCurrentStatedata.currentState? cpmCurrentStatedata.currentState:" - "}</div> */}
                                        {/* </Card> */}
                                    {/* </Grid> */}
                                </Grid>
                            </Grid>
                    </Grid>
                </Grid>
                {/* Right part */}
                <Grid item xs={12} spacing={1} sm={12} md={3} lg={3} xl={3} xxl={3} style={{marginTop:"1vh"}}>
                              <Grid container item xs={12} spacing={1} direction='column'>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                      <Grid container xs={12} spacing ={2} direction="row" style={{marginTop:'-1vh',display:'flex',justifyContent:'center'}}>
                                                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} style={{display:'flex',justifyContent:'left'}}>
                                                        <Typography variant="string" style={{color:'black',fontWeight:'bold',fontSize:'1.8vh'}}>
                                                             CPM
                                                        </Typography>
                                                      </Grid>
                                                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                                                      <div className="your-required-wrapper"
                                                          style={{ width: "20vh", marginLeft: "0vh",height:"3.5vh" }}>
                                                                    <SwitchSelector
                                                                      onChange={onChangeCPMStatus}
                                                                      options={options}
                                                                      // initialSelectedIndex={initialSelectedIndex}
                                                                      forcedSelectedIndex={cpmAutoManualStatus}
                                                                      backgroundColor={"rgba(0, 0, 0, 0.04)"}
                                                                      fontColor={"#000"}
                                                                      selectedFontColor={"#000"}
                                                                      // border="5"
                                                                      optionBorderRadius={5}
                                                                      wrapperBorderRadius={8}
                                                                      fontSize={11}
                                                                    />
                                                                  </div>
                                                      </Grid>
                                                      {/* <Grid item xs={2} style={{display:'flex',justifyContent:'center'}}><CreateIcon style={{cursor:'pointer'}}  onClick={() => onClickTriggerIcon('Icon')}/></Grid> */}
                                      </Grid>
                                      <Grid container xs={12} spacing ={2} direction="row" style={{marginTop:'-1vh',display:'flex',justifyContent:'center'}}>
                                                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} style={{display:'flex',justifyContent:'center'}}>
                                                        <Typography variant="string" style={{color:'black',fontWeight:'bold',fontSize:'1.8vh'}}>
                                                              Primary Pump Sequencing Panel
                                                        </Typography>
                                                      </Grid>
                                                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                                                      <div className="your-required-wrapper"
                                                          style={{ width: "20vh", marginLeft: "0vh",pointerEvents:cpmAutoManualStatus ==  1 ? "none":"", opacity:cpmAutoManualStatus ==  1?"0.4":"",height:"3.5vh",  }}>
                                                                   <SwitchSelector
                                                                      // style={{ borderRadius: "12px" }}
                                                                      onChange={onChangeSEQpanel}
                                                                      options={options2}
                                                                      forcedSelectedIndex={opn_SS}
                                                                      backgroundColor={"#e9e5e5"}
                                                                      fontColor={"rgba(0, 0, 0, 0.87)"}
                                                                      optionBorderRadius={5}
                                                                      wrapperBorderRadius={5} 
                                                                      fontSize={11}/>
                                                                  </div>
                                                      </Grid>
                                                      {/* <Grid item xs={2} style={{display:'flex',justifyContent:'center'}}><CreateIcon style={{cursor:'pointer'}}  onClick={() => onClickTriggerIcon('Icon')}/></Grid> */}
                                      </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                        <Box className={classes.graphpaper1} style={{height: window.innerHeight == '1080'?'22.7vh':"19.25vh",}}>
                                          <Grid container item xs={12} spacing={1}>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                              {/* <Card className={`${classes.CardHeadFont}`} style={{fontWeight:'bold',color:'black'}}> */}
                                                <div style={{overflow: 'auto'}}>
                                                  Current Scenario: {cpmCurrentStatedata.currentScenario? cpmCurrentStatedata.currentScenario: " - "} 
                                                  <br />
                                                  Current State: {cpmCurrentStatedata.currentState? cpmCurrentStatedata.currentState:" - "}
                                                </div>
                                                {/* {window.innerHeight} */}
                                              {/* </Card>  */}
                                            </Grid>
                                          </Grid>
                                          {/* <Grid container item xs={12} spacing={1}>
                                              <Grid item xs={6} sm={6} md={6} lg={6} xl={6} xxl={6}>
                                                  <Card className={`${classes.semicircularbar} ${classes.CardHeadFont}`} style={{fontWeight:'bold',color:'black',boxShadow:"1px 0px 8px 2px rgba(0, 0, 0, 0.14)", backgroundColor:"#Fefefa"}}>
                                                    Plant Power[kW]
                                                  <div className={classes.semicircularbarcomp}>
                                                    <SemiCircleProgressBar
                                                        stroke="#0123b4"
                                                        strokeWidth={20}
                                                        diameter={100}
                                                        orientation="up"
                                                        percentage={50} // Set the value here
                                                    // showPercentValue
                                                    />
                                                <div style={{ marginTop: '-2vh', fontSize: '10px' }}>50</div>
                                                </div>
                                                  </Card>
                                              </Grid>
                                              <Grid item xs={6} sm={6} md={6} lg={6} xl={6} xxl={6}>
                                                  <Card className={`${classes.semicircularbar} ${classes.CardHeadFont}`} onClick={() => handleClick('Plant Load')} style={{fontWeight:'bold',color:'black',cursor:'pointer'}}>
                                                    Plant Load
                                                  <div className={classes.semicircularbarcomp}>
                                                    <SemiCircleProgressBar
                                                        stroke="#0123b4"
                                                        strokeWidth={20}
                                                        diameter={100}
                                                        orientation="up"
                                                        percentage={50} // Set the value here
                                                    // showPercentValue
                                                    />
                                                <div style={{ marginTop: '-2vh', fontSize: '10px' }}>50</div>
                                                </div>
                                                  </Card>
                                              </Grid>
                                              <Grid item xs={6} sm={6} md={6} lg={6} xl={6} xxl={6}>
                                                  <Card className={`${classes.semicircularbar} ${classes.CardHeadFont}`} 
                                                  onClick={() => handleClick('Plant kW/TR')}
                                                  style={{fontWeight:'bold',color:'black',cursor:'pointer'}}>
                                                    Plant kW/TR
                                                    <div className={classes.semicircularbarcomp}>
                                                    <SemiCircleProgressBar
                                                        stroke="#0123b4"
                                                        strokeWidth={20}
                                                        diameter={100}
                                                        orientation="up"
                                                        percentage={50} // Set the value here
                                                    // showPercentValue
                                                    />
                                                <div style={{ marginTop: '-2vh', fontSize: '10px' }}>50</div>
                                                </div> 
                                                  </Card>
                                              </Grid>
                                              <Grid item xs={6} sm={6} md={6} lg={6} xl={6} xxl={6}>
                                                  <Card className={classes.semicircularbar}
                                                    style={{fontWeight:'bold',color:'black',cursor:'pointer'}}>
                                                      <div  className={classes.CardHeadFont}
                                                  //     onMouseEnter={handleMouseEnter}
                                                  // onMouseLeave={handleMouseLeave}
                                                  >
                                                    Run Hours
                                                  </div>
                                                  <div  onClick={() => handleClick('Run Hours')} style={{fontWeight:'bold',color:'#0123B4',fontSize:'3.5vh',marginTop:'-1vh'}}>400</div>
                                                  </Card>
                                              </Grid>
                                          </Grid> */}
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                        <Box className={classes.graphpaper}>
                                          <div style={{fontWeight:'bold',color:'black'}} className={classes.CardHeadFont}>CW Header Return Temperature[°C]</div>
                                          <TimeS
                                          name='CW Header Return Temperature'
                                          data={CWH_RT}
                                          data24Hr={CWH_RT24Hr}
                                          minRange='0'
                                          maxRange='20'
                                      style={{ width: "100%", height: "100%" }}
                                    ></TimeS>
                                        </Box>
                                    </Grid>
                                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                        <Box className={classes.graphpaper}>
                                          <div style={{ fontWeight: 'bold', color: 'black' }} className={classes.CardHeadFont}>CW Header Supply Temperature[°C]</div>
                                          <TimeS
                                            name='CW Header Supply Temperature'
                                            data={CWH_ST}
                                            data24Hr={CWH_ST24Hr}
                                            minRange='0'
                                            maxRange='20'
                                            style={{ width: "100%", height: "100%" }}
                                          ></TimeS>
                                        </Box>
                                      </Grid>
                                </Grid>
                </Grid>
            </Grid>
            {/* <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title"  open={modal} classes={{ paper: classes.customDialog }}>
                      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                     {modalHeading}
                      </DialogTitle>
                      <DialogContent dividers>
                      <TimeS
                                  // name='kW/TR'
                                  data={dataSeries}
                                  style={{ width: "100%", height: "50%" }}
                                  // style={{ width: "100%", height: "100%" }}
                                ></TimeS>
                      </DialogContent>
            </Dialog>   */}
             <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title"  open={pumpModal} classes={{ paper: classes.customDialogPump }}>
                      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                           {pumpData[3]||pumpType}
                      </DialogTitle>
                      <DialogContent dividers>
                          <PumpPage type={pumpType} data={pumpData} click='eachPump'/>
                      </DialogContent>
            </Dialog>  
            {/* <Dialog onClose={handleClose2} aria-labelledby="customized-dialog-title"  open={modal2} classes={{ paper: classes.customDialog }}>
                      <DialogTitle id="customized-dialog-title" onClose={handleClose2}>
                     Reports
                      </DialogTitle>
                      <DialogContent dividers>
                      <ChillerReports data={'Jahnavi'}/>
                     </DialogContent>
            </Dialog>   */}
             <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title"  open={triggerModal} classes={{ paper: classes.customDialogPump }}>
                      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                           CPM
                      </DialogTitle>
                      <DialogContent dividers>
                          <Grid container item xs={12} spacing={1}>
                                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                          {/* <Box className={classes.childpaper} style={{height:'17.5vh'}}> */}
                                                <Grid container item xs={12} direction="column">
                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                                                      <Card className={classes.graphpaper} style={{height:'20.5vh',width:'72vh',display:'flex',justifyContent:'center',alignItems:'center',fontWeight:'bold'}}>{cpmres}</Card>
                                                    </Grid>
                                                    </Grid>
                                                    <Grid container item xs={12} direction="row" style={{marginTop:'3vh',marginLeft:'2vh'}}>
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}></Grid>
                                                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4} xxl={4}>
                                                        <Paper className={classes.faults_paper} onClick={()=>onClickOfTrigger('start')} style={{cursor:'pointer',height:'5vh',color:'white',width:'20vh',backgroundColor:'#0123B4',display:'flex',justifyContent:'center',alignItems:'center'}}>
                                                          Start
                                                        </Paper>
                                                    </Grid>
                                                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4} xxl={4}>
                                                    <Paper className={classes.faults_paper} onClick={()=>onClickOfTrigger('updates')} style={{cursor:'pointer',color:'white',height:'5vh',width:'20vh',backgroundColor:'#0123B4',display:'flex',justifyContent:'center',alignItems:'center'}}>
                                                          Check updates
                                                        </Paper>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}></Grid>
                                                </Grid>
                                          {/* </Box>                             */}
                                      </Grid>
                          </Grid>
                      </DialogContent>
            </Dialog> 
            <SemanticToastContainer position="top-center" /> 
    </div>
  )
}
